// Module
var code = "<div class=\"container-close\" ng-click=\"$ctrl.exit()\"></div> <generic-form header=\"$ctrl.header\" subheader=\"$ctrl.subheader\" fields-list=\"$ctrl.currentFields\" submit-button-text=\"$ctrl.submitButtonText\" on-submit=\"$ctrl.submit(form)\" on-close=\"$ctrl.exit()\" on-update=\"$ctrl.handleUpdate(fieldName, value)\"></generic-form> ";
// Exports
module.exports = code;